import styled from "styled-components";
import StyledLink from "../../../../shared/components/global/StyledLink";
import { Button, ButtonSizes } from "../../../../shared/styles/button";
import {
  Container,
  ContainerContentStandard,
} from "../../../../shared/styles/container";
import { device } from "../../../../shared/styles/device";
import { SubcategoryTagReadOnly } from "../../../../shared/styles/tag";
import { enumKeys } from "../../../../shared/utils/enumkeys";
import { Discipline } from "../../model/talentpool/discipline";

const AreasSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  background-color: #f5f5f7;
  border-radius: 0px ${(props) => props.theme.borderRadiusSectionMobile}
    ${(props) => props.theme.borderRadiusSectionMobile} 0px;
  margin-bottom: 32px;
  margin-top: 64px;

  @media ${device.tablet} {
    border-radius: 0px ${(props) => props.theme.borderRadiusSection}
      ${(props) => props.theme.borderRadiusSection} 0px;
  }

  h2 {
    font-size: 26px;
    margin-top: 32px;
    margin-bottom: 32px;
    @media ${device.tablet} {
      font-size: 32px;
      margin-top: 42px;
      margin-bottom: 42px;
    }
    text-align: center;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 42px;
`;
export const AreasGrid = styled.div`
  column-gap: 0px;
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 48px;
  margin-top: 48px;
  row-gap: 24px;
  width: 100%;

  @media ${device.laptop} {
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
  }
`;

const SubcategoryTagsCentered = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  margin-bottom: 32px;
  column-gap: 8px;
  row-gap: 8px;
`;

export const AreasSection = () => {
  return (
    <AreasSectionContainer>
      <Container>
        <ContainerContentStandard>
          <h2>
            In diesen <span>Disziplinen</span> kannst du dich bewerben.
          </h2>
          <SubcategoryTagsCentered>
            {enumKeys(Discipline).map((key: keyof typeof Discipline, index) => (
              <SubcategoryTagReadOnly key={key + index}>
                {Discipline[key]}
              </SubcategoryTagReadOnly>
            ))}
          </SubcategoryTagsCentered>
          <ButtonContainer>
            <StyledLink href="/register/talent/">
              <Button primary size={ButtonSizes.m}>
                Jetzt kostenfrei registrieren
              </Button>
            </StyledLink>
          </ButtonContainer>
        </ContainerContentStandard>
      </Container>
    </AreasSectionContainer>
  );
};
